import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useEventSkuTimeseries({
  eventId,
  produto,
  period,
  baseline = null,
  janela = null,
  enabled = true,
}) {
  const { getEventSkuTimeseries } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;

  return useQuery({
    queryKey: [
      "eventSkuTimeseries",
      user?.user_id ?? null,
      branchId,
      eventId,
      produto,
      period,
      baseline,
      janela,
    ],
    queryFn: () =>
      getEventSkuTimeseries(eventId, produto, {
        period,
        ...(baseline ? { baseline } : {}),
        ...(janela ? { janela } : {}),
      }),
    enabled: enabled && !!branchId && !!eventId && !!produto,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
